import util from 'src/util/util';

/**
 * Created by huzhongchun on 2018/4/26.
 */

//project_label
export const PROJECT_LABEL = 'READING';

//route base path
export const PRODUCT_ROUTE_BASE_PATH = '/chicken/page/entrance';
export const DEVELOPMENT_ROUTE_BASE_PATH = '';

//api host
export const API_ONLINE_HOST = window.location.protocol+'//api.thefair.net.cn';

//get token
export const GET_TOKEN_URL = '/chicken/page/get_token';
export const GET_TOKEN_REQUEST_BASEURL = window.location.origin;
export const GET_TOKEN_REQUEST_TYPE = 'chicken';

export default {
	PRODUCT_ROUTE_BASE_PATH,
	DEVELOPMENT_ROUTE_BASE_PATH,
	API_ONLINE_HOST,
	GET_TOKEN_URL,
};



// WEBPACK FOOTER //
// ./src/config/configReading.js